module.exports = {
  lg: {}
}